module.exports = {
  lg: {}
}